import styles from "./ViewByModal.module.css";
import PropTypes from "prop-types";

import RadioButtonList from "ManagementTeam/Shared/RadioButtonList";
import { useState } from "react";

/**
 *
 * Changes the order diamonds are displayed in on the home page.
 *
 */

export function ViewByModal({ isOpen, onCollapse, onChange, selectedOption }) {
  function handleChange(value) {
    onChange(value);
  }

  return (
    <div className={styles.container}>
      <div className={styles.title}>View By</div>
      <div className={styles.hr} />

      <RadioButtonList
        selectedOption={selectedOption}
        direction="vertical"
        options={[
          "Alphabetical",
          "Current GAR Points",
          "Management Team Group",
          "Pin Level (current wearing)",
          "Checked In",
        ]}
        onClick={handleChange}
      />

      <button className={styles.button} onClick={onCollapse}>
        Close
      </button>
    </div>
  );
}

ViewByModal.propTypes = {
  isOpen: PropTypes.bool,
  onCollapse: PropTypes.func,
  onChange: PropTypes.func,
};
